module.exports = __webpack_public_path__ + "static/media/close-filled-purple.019df161.svg";